import current from "@/store/modules/users/current";
import details from "@/store/modules/users/details";
import invite from "@/store/modules/users/invite";
import list from "@/store/modules/users/list";
import search from "@/store/modules/users/search";
import location from "@/store/modules/users/location";
import customAttribute from "@/store/modules/users/customAttribute";

export default {
    namespaced: true,
    modules: {
        current,
        details,
        invite,
        list,
        search,
        location,
        customAttribute,
    },
};
